<template>
  <div class="packing">
    <!-- S : 공통 타이틀 영역 -->
    <div class="box_title_area">
      <!-- 2020-11-12 텍스트 수정 -->
      <div class="promotion price-tip tooltip-a">
        <div class="promotion-tip">
          <h3
            class="tooltip-btn service-title-b"
            @click="changeTooltipStatus"
          >
            나만의 팩에 이름을 붙여 관리하세요.<span class="mark">(필수)</span>
          </h3>
        </div>
        <div
          class="promotion-tip-alert"
          :style="onTooltip"
        >
          <ul class="square-list">
            <li>
              <p>마이팩 명은 한글, 영어로 작성 가능하며 최대 10자로 입력해 주세요.</p>
            </li>
            <li>
              <p>질병치료 및 예방, 허위과대, 비속어 등의 표현은 사용하실 수 없습니다.</p>
            </li>

          </ul>
        </div>
      </div>
    </div>
    <!-- E : 공통 타이틀 영역 -->
    <div class="nameplate_box">
      <div class="inner">
        <span><input
          ref="refInputPackName"
          type="text"
          placeholder="ex) 에브리데이 팩"

          v-model="packName"
          @input="checkPackNameLength"
          @blur="finalizeInput"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>

const chunjiinDot = ['ㆍ', 'ᆢ'];
const disallowedPatternsWhileTyping = /[^ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|A-Z|0-9|ㆍ|ᆢ| ]|\|/g;
const disallowedPatternsFinal = /[^ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|A-Z|0-9| ]|\|/g;
export default {
  name: 'PackNamingSection',
  props: {
    value: {
      type: String,
      default: '',
    },
    maxLength: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      packName: this.value,
      onTooltip: 'display: none',
    };
  },
  created() {
    this.packName = this.packName.slice(0, 10);
  },
  methods: {
    checkPackNameLength(evt) {
      if (this.packName === ' ') {
        this.packName = '';
        return;
      }
      console.log(evt.target.value);
      const valueInput = evt.target.value;
      const last = valueInput.slice(valueInput.length - 1, valueInput.length);
      if (valueInput.length > 0 && chunjiinDot.includes(last)) {
        // 천지인 컴포지션 중이라 간주.
        return;
      }

      const preceding = valueInput.slice(0, valueInput.length - 1);

      console.log(preceding, ' - ', last);
      const val = (preceding ? preceding.replace(disallowedPatternsFinal, '') : '')
        + last.replace(disallowedPatternsWhileTyping, '');

      console.log(val);
      if (val.length > this.maxLength) {
        this.packName = val.slice(0, this.maxLength);
        // 한글은 자소의 조합이 IME를 통해 입력되므로 한 글자의 입력완료여부가 불투명함
        // 또한, 입력값이 변경 된 후 실제 조작된 데이터와 화면에 보이는 입력값이 다르게 보이는 순간이 존재하므로,
        // 강제로 input 요소를 업데이트 해줘야 함.
        this.$refs.refInputPackName.value = this.packName;
      } else {
        this.packName = val;
      }
      this.$emit('input', this.packName);
    },
    finalizeInput() {
      this.packName = this.packName.replace(disallowedPatternsFinal, '');

      if (this.packName.length > this.maxLength) {
        this.packName = this.packName.slice(0, this.maxLength);
      }
      
      this.$emit('input', this.packName);
      setTimeout(() => {
        // safari heck
        this.$refs.refInputPackName.value = this.packName;
      }, 0);
    },
    changeTooltipStatus() {
      if (this.onTooltip === 'display: none') {
        this.onTooltip = 'display: block';
      } else {
        this.onTooltip = 'display: none';
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/composition/main/step3/PackNamingSection.vue